module.exports = "<svg version=\"1.1\" id=\"dark_gray_left\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" width=\"6.2px\" height=\"10px\" viewBox=\"0 0 6.2 10\" enable-background=\"new 0 0 6.2 10\" xml:space=\"preserve\"><polygon fill=\"#007FAD\" points=\"0,1.4 1.4,0 6.2,4.8 6.2,5.2 1.4,10 0,8.6 3.6,5 \"></polygon></svg>"


/*****************
 ** WEBPACK FOOTER
 ** ./~/svg-inline-loader?removeSVGTagAttrs=false!./src/img/arrow_blue_right.svg
 ** module id = 1008
 ** module chunks = 0
 **/